// Cards SVG hain — code se bante hain, koi tasveer nahi.
// Faida: har card ~2 KB (tasveer 200 KB), rang badalne par nayi tasveer nahi banti,
// har screen par saaf, aur bilkul apne (kisi ka copyright nahi).

export const BG_COLORS = [
  '#E1F5EE', '#9FE1CB', '#0F6E56', '#085041',
  '#FBEAF0', '#F4C0D1', '#D4537E', '#72243E',
  '#E6F1FB', '#B5D4F4', '#185FA5', '#0C447C',
  '#FAEEDA', '#FAC775', '#BA7517', '#633806',
  '#F1EFE8', '#D3D1C7', '#5F5E5A', '#131C19',
];

// Gehre rang par safaid matn, halke par gehra
export function inkFor(bg) {
  const h = bg.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? '#131C19' : '#FFFFFF';
}

export const DESIGNS = [
  { key: 'cake', label: 'Cake', occasions: ['birthday'], defaultBg: '#E1F5EE' },
  { key: 'balloons', label: 'Balloons', occasions: ['birthday', 'congrats'], defaultBg: '#FBEAF0' },
  { key: 'hearts', label: 'Hearts', occasions: ['anniversary', 'just_because'], defaultBg: '#FBEAF0' },
  { key: 'plus', label: 'Get well', occasions: ['get_well'], defaultBg: '#E6F1FB' },
  { key: 'star', label: 'Star', occasions: ['thank_you', 'congrats'], defaultBg: '#FAEEDA' },
  { key: 'leaf', label: 'Leaf', occasions: ['sympathy', 'just_because'], defaultBg: '#F1EFE8' },
];

// Har design ek function — bg aur ink de kar SVG ka andar wala hissa milta hai
const ART = {
  cake: (ink) => `
    <circle cx="100" cy="82" r="38" fill="${ink}" opacity="0.9"/>
    <rect x="80" y="70" width="40" height="30" rx="3" fill="none" stroke="${ink}" stroke-width="0"/>
    <rect x="80" y="70" width="40" height="30" rx="3" fill="rgba(255,255,255,0)"/>
    <line x1="88" y1="70" x2="88" y2="56" stroke="${ink}" stroke-width="2.5" stroke-linecap="round" opacity="0.9"/>
    <line x1="100" y1="70" x2="100" y2="50" stroke="${ink}" stroke-width="2.5" stroke-linecap="round" opacity="0.9"/>
    <line x1="112" y1="70" x2="112" y2="56" stroke="${ink}" stroke-width="2.5" stroke-linecap="round" opacity="0.9"/>
    <circle cx="88" cy="53" r="3" fill="${ink}"/>
    <circle cx="100" cy="47" r="3" fill="${ink}"/>
    <circle cx="112" cy="53" r="3" fill="${ink}"/>`,
  balloons: (ink) => `
    <ellipse cx="80" cy="62" rx="18" ry="23" fill="${ink}" opacity="0.9"/>
    <ellipse cx="118" cy="70" rx="15" ry="19" fill="${ink}" opacity="0.55"/>
    <path d="M80 85 Q76 100 82 116" fill="none" stroke="${ink}" stroke-width="1.5" opacity="0.6"/>
    <path d="M118 89 Q122 102 116 116" fill="none" stroke="${ink}" stroke-width="1.5" opacity="0.6"/>`,
  hearts: (ink) => `
    <path d="M100 104 C82 88 70 76 70 63 C70 52 79 47 88 51 C93 53 98 58 100 62 C102 58 107 53 112 51 C121 47 130 52 130 63 C130 76 118 88 100 104 Z" fill="${ink}" opacity="0.9"/>
    <path d="M72 112 C60 101 52 93 52 84 C52 77 58 73 64 76 C67 77 70 81 72 83 C74 81 77 77 80 76 C86 73 92 77 92 84 C92 93 84 101 72 112 Z" fill="${ink}" opacity="0.45"/>`,
  plus: (ink) => `
    <circle cx="100" cy="76" r="32" fill="${ink}" opacity="0.28"/>
    <path d="M100 58 L100 94 M82 76 L118 76" stroke="${ink}" stroke-width="9" stroke-linecap="round"/>
    <circle cx="66" cy="48" r="4" fill="${ink}" opacity="0.5"/>
    <circle cx="134" cy="56" r="3" fill="${ink}" opacity="0.5"/>
    <circle cx="128" cy="104" r="5" fill="${ink}" opacity="0.5"/>`,
  star: (ink) => `
    <path d="M100 48 L108 70 L131 70 L112 84 L119 106 L100 92 L81 106 L88 84 L69 70 L92 70 Z" fill="${ink}" opacity="0.9"/>
    <circle cx="66" cy="100" r="3" fill="${ink}" opacity="0.5"/>
    <circle cx="134" cy="98" r="4" fill="${ink}" opacity="0.5"/>`,
  leaf: (ink) => `
    <path d="M100 116 C100 116 66 96 66 68 C66 54 82 44 100 44 C118 44 134 54 134 68 C134 96 100 116 100 116 Z" fill="${ink}" opacity="0.85"/>
    <line x1="100" y1="52" x2="100" y2="110" stroke="${ink}" stroke-width="1" opacity="0.35"/>`,
};

/**
 * Card ka SVG. width bhar leta hai.
 * @param {string} design  DESIGNS me se key
 * @param {string} bg      hex
 * @param {string} head    bari sarkhi
 * @param {string} sub     chhoti line (khali chhod sakte hain)
 */
export function cardSvg(design, bg, head, sub) {
  const ink = inkFor(bg);
  const art = (ART[design] || ART.cake)(ink);
  const esc = (s) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:auto;display:block">
  <rect width="200" height="200" rx="14" fill="${bg}"/>
  ${art}
  <text x="100" y="150" text-anchor="middle" font-family="system-ui,-apple-system,sans-serif" font-size="14" font-weight="600" fill="${ink}">${esc(head)}</text>
  ${sub ? `<text x="100" y="170" text-anchor="middle" font-family="system-ui,-apple-system,sans-serif" font-size="10" fill="${ink}" opacity="0.75">${esc(sub)}</text>` : ''}
</svg>`;
}

export const OCCASIONS = [
  { key: 'birthday', icon: '🎂', label: 'Birthday', head: 'Happy birthday' },
  { key: 'anniversary', icon: '💍', label: 'Anniversary', head: 'Happy anniversary' },
  { key: 'get_well', icon: '💙', label: 'Get well soon', head: 'Get well soon' },
  { key: 'thank_you', icon: '⭐', label: 'Thank you', head: 'Thank you' },
  { key: 'congrats', icon: '🎉', label: 'Congratulations', head: 'Congratulations' },
  { key: 'sympathy', icon: '🤍', label: 'Care & concern', head: 'Thinking of you' },
  { key: 'just_because', icon: '💌', label: 'Just because', head: 'For you' },
];
